import { Component, Input } from '@angular/core';
import { IFaqItem } from '@shared/common/interfaces/faq-card.interface';


@Component({
    selector: 'app-faq-card',
    templateUrl: './faq-card.component.html',
    styleUrl: './faq-card.component.scss',
    standalone: false
})
export class FaqCardComponent {

  @Input() faqs: IFaqItem[] = [];
  @Input() titleFaq: string | null = null;
  @Input() subTitleFaq: string | null = null;
  @Input() isReforma?: boolean = false;
  @Input() tipoBeneficio?: string = '';


  toggleFaq(index: number) {
    this.faqs = this.faqs.map((item, i) =>
      i === index ? { ...item, isOpen: !item.isOpen } : { ...item, isOpen: false }
    );

     // Espera a que el DOM se actualice y enfoca el elemento abierto
  setTimeout(() => {
    const element = document.getElementById(`faq-item-${index}-${this.getTipoFaqs}`);
    if (element && this.faqs[index].isOpen) {
      element.focus();
    }
  }, 5);
  }

  get getTipoFaqs() {
   return (this.titleFaq?.includes('preguntas') || this.titleFaq?.includes('Preguntas')) ? 'preguntas' : 'modalidad';
  }

  goToChileAtiende(){
    const url = 'https://mi.chileatiende.gob.cl/tramites/102077';
    window.open(url, '_blank');
  }

}
